<style scoped lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/report/page/dead_inventory_report" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('wuliaomingcheng')">
            <yi_data_select :multiple="true" :type="'material2'" :ids.sync="yt.conditions.materialId"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('riqi')">
            <yi_time_input format="yyyy-MM-dd" type="date" :time.sync="yt.conditions.createTime"></yi_time_input>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('gongyingshangmingcheng')">
            <yi_cross_select multiple :component="'web_wms_purchase_receipt_supplier_information'" :ids.sync="yt.conditions.supplierId"> </yi_cross_select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1, null, afterReq)" type="primary" plain>
              {{ $t("sousuo") }}
            </el-button>
            <el-button @click="yt.clear(null, null, afterReq)">{{ $t("chongzhi") }} </el-button>
            <yi_curd_expand_button :isAutoExpand="true"></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>

      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-export" :title="$t('daochu')" :loading="exportLoading" @click="exportExcel()"></el-button>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
      <template #footer>
        <!-- 这里可以在底部填写东西 -->
        <div style="display: flex;flex-wrap: nowrap;justify-content: flex-start;align-items: center;">
          <div style="font-size: 17px;font-weight: bold">
            {{ $t("heji") }}
          </div>
          <div style="margin-left: 8px;color: #606266;font-size: 14px">
            <span style="font-size: 14px;font-weight: bold">{{ $t("yigeyue(shuliang)") }}:</span>
            <span style="margin-left: 8px">{{ oneMonthSum }}</span>
          </div>
          <div style="margin-left: 12px;color: #606266;font-size: 14px">
            <span style="font-weight: bold">{{ $t("sangeyue(shuliang)") }}:</span>
            <span style="margin-left: 8px">{{ threeMonthSum }}</span>
          </div>
          <div style="margin-left: 12px;color: #606266;font-size: 14px">
            <span style="font-weight: bold">{{ $t("liugeyue(shuliang)") }}:</span>
            <span style="margin-left: 8px">{{ sixMonthSum }}</span>
          </div>
          <div style="margin-left: 12px;color: #606266;font-size: 14px">
            <span style="font-weight: bold">{{ $t("sanshiqigeyue(shuliang)") }}:</span>
            <span style="margin-left: 8px">{{ thirtySevenMonthSum }}</span>
          </div>
          <div style="margin-left: 12px;color: #606266;font-size: 14px">
            <span style="font-weight: bold">{{ $t("kucunheshu(shuliang)") }}:</span>
            <span style="margin-left: 8px">{{ totalSum }}</span>
          </div>
        </div>
      </template>
    </yi_curd_table>
  </div>
</template>
<script type="text/javascript">
export default {
  name: "web_report_dead_inventory_report_list",

  data() {
    return {
      exportLoading: false,
      oneMonthSum: 0,
      threeMonthSum: 0,
      sixMonthSum: 0,
      thirtySevenMonthSum: 0,
      totalSum: 0,
      list: [],
      totalExtend: {},
      columns: [
        {
          label: "wuliaobianma",
          prop: "materialCode",
          // type: 'time',
          width: 130,
        },
        {
          label: "wuliaomingcheng",
          prop: "materialName",
          width: 130,
        },
        {
          label: "chanpinfenlei",
          prop: "materialValue",
          type: "dictionary",
          key: "GYLXCPFL",
          // width: 130,
        },
        {
          label: "gongyingshangmingcheng",
          prop: "supplierName",
          width: 130,
        },
        {
          label: "danwei",
          prop: "unit",
          type: "dictionary",
          key: "UNIT_CONVERSION_TYPE",
          width: 130,
        },
        {
          label: "yigeyue(shuliang)",
          prop: "oneMonthQuantity",
          width: 130,
        },
        {
          label: "sangeyue(shuliang)",
          prop: "threeMonthQuantity",
          width: 130,
        },
        {
          label: "liugeyue(shuliang)",
          prop: "sixMonthQuantity",
          width: 130,
        },
        {
          label: "sanshiqigeyue(shuliang)",
          prop: "thirtySevenMonthQuantity",
          width: 150,
        },
        {
          label: "kucunheshu(shuliang)",
          prop: "totalQuantity",
          width: 150,
        },
      ],
    };
  },
  created() {
    setTimeout(() => {
      this.yt.get(1, null, this.afterReq);
    }, 300);
  },
  methods: {
    afterReq(results) {
      this.oneMonthSum = 0;
      this.threeMonthSum = 0;
      this.sixMonthSum = 0;
      this.thirtySevenMonthSum = 0;
      this.totalSum = 0;
      for (let i = 0; i < results.data.rows.length; i++) {
        this.oneMonthSum += results.data.rows[i].oneMonthQuantity;
        this.threeMonthSum += results.data.rows[i].threeMonthQuantity;
        this.sixMonthSum += results.data.rows[i].sixMonthQuantity;
        this.thirtySevenMonthSum += results.data.rows[i].thirtySevenMonthQuantity;
        this.totalSum += results.data.rows[i].totalQuantity;
      }
      return results;
    },

    exportExcel() {
      this.exportLoading = true;
      let params = this.yt.conditions;
      return this.http
        .get("/web/report/export/dead_inventory_report", {
          params,
        })
        .then((res) => {
          this.exportLoading = false;
          this.$message.success(this.$t(res.msg));
          this.utils.event_hub.$emit("SHOW_HEADER_EXPORT_DIALOG");
        })
        .catch((error) => {
          this.$message.error(this.$t(error));
          this.exportLoading = false;
        });
    },
    // 重置
    // clear() {
    // 	this.yt.conditions = {
    // 		createTimeStart: this.begin(),
    // 		createTimeEnd: this.end()
    //
    // 	}
    // 	this.yt.list = []
    // },
  },
};
</script>
